import React, { createContext, useContext, useState } from "react";

const NIAContext = createContext();

export const NIAProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);
  const [clientName, setClientName] = useState("");

  return (
    <NIAContext.Provider value={{ messages, setMessages, clientName, setClientName }}>
      {children}
    </NIAContext.Provider>
  );
};

export const useNIA = () => useContext(NIAContext);
